// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simplestream .pausead-container {
    position: absolute; 
    top: 0px; 
    left: 0px; 
    width: 100%; 
    height: 100%;
    display: flex; 
    flex-direction: column; 
    z-index: -1;
    background: black;
}
.simplestream .pausead-container .pausead-safearea {
    flex-grow: 1; 
    width: 100%; 
    height: 100%; 
    display: flex; 
    align-items: center; 
    justify-content: center;
}
.simplestream .pausead-container .pausead-controls {
    padding: 10px; 
    display: flex; 
    justify-content: center;
}
.simplestream .pausead-container .pausead-controls .pausead-button {
    padding: 10px 20px; 
    color: white;
    cursor: pointer;
    border: 1px solid white;
}
.simplestream .pausead-container .pausead-slot {
    display: block; /* no pause ad by defult */
    width: 320px;
    height: 100px;
}

.simplestream .pausead-container .pausead-slot .pause-AdSlot {
    position: relative;
    width:  100%;   /* or fixed px */
    height: 100%;
}

/* 2. IMA’s wrapper is created with class ima-ad-container */
.simplestream .pausead-container .pausead-slot .ima-ad-container {
    position: absolute !important;
    inset: 0;               /* top:0 right:0 bottom:0 left:0  */
    display: flex;          /* centre everything inside         */
    align-items: center;
    justify-content: center;
}

/* 3. creative iframe (IMA injects it) becomes flex item */
.simplestream .pausead-container .pausead-slot .ima-ad-container iframe {
    max-width: 100%;
    max-height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/plugins/pausead/PauseAdPlugin.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,cAAc,EAAE,0BAA0B;IAC1C,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY,IAAI,gBAAgB;IAChC,YAAY;AAChB;;AAEA,4DAA4D;AAC5D;IACI,6BAA6B;IAC7B,QAAQ,gBAAgB,mCAAmC;IAC3D,aAAa,WAAW,qCAAqC;IAC7D,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,0DAA0D;AAC1D;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".simplestream .pausead-container {\n    position: absolute; \n    top: 0px; \n    left: 0px; \n    width: 100%; \n    height: 100%;\n    display: flex; \n    flex-direction: column; \n    z-index: -1;\n    background: black;\n}\n.simplestream .pausead-container .pausead-safearea {\n    flex-grow: 1; \n    width: 100%; \n    height: 100%; \n    display: flex; \n    align-items: center; \n    justify-content: center;\n}\n.simplestream .pausead-container .pausead-controls {\n    padding: 10px; \n    display: flex; \n    justify-content: center;\n}\n.simplestream .pausead-container .pausead-controls .pausead-button {\n    padding: 10px 20px; \n    color: white;\n    cursor: pointer;\n    border: 1px solid white;\n}\n.simplestream .pausead-container .pausead-slot {\n    display: block; /* no pause ad by defult */\n    width: 320px;\n    height: 100px;\n}\n\n.simplestream .pausead-container .pausead-slot .pause-AdSlot {\n    position: relative;\n    width:  100%;   /* or fixed px */\n    height: 100%;\n}\n\n/* 2. IMA’s wrapper is created with class ima-ad-container */\n.simplestream .pausead-container .pausead-slot .ima-ad-container {\n    position: absolute !important;\n    inset: 0;               /* top:0 right:0 bottom:0 left:0  */\n    display: flex;          /* centre everything inside         */\n    align-items: center;\n    justify-content: center;\n}\n\n/* 3. creative iframe (IMA injects it) becomes flex item */\n.simplestream .pausead-container .pausead-slot .ima-ad-container iframe {\n    max-width: 100%;\n    max-height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
